import React from "react";
import "./Footer.css";

function Footer() {

    return (
        <footer className="footer">
            <div className="container">
                <p className="text-right powered-by">
                    Powered by&nbsp;
                    <a href="https://www.subtrux.com" target="_blank" rel="noopener noreferrer">
                        <img className="subtrux-logo" src="subtrux_black_321_80.png" width="161" height="40" alt="SubTrux Logo"/>
                    </a>
                </p>
                {/*<span className="text-muted">Place sticky footer content here.</span>*/}
            </div>
        </footer>
    )

}

export default Footer;
